import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { topics } from "@/mocks/topics";

export default function TopicsSection() {
  const [feature, ...others] = topics;

  return (
    <section className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="热门专题"
          title="把零散线索拼成一张图"
          desc="当多篇爆料指向同一条逻辑，我们会把它们收进专题，按时间与线索重新排列。"
          actionHref="/topics"
          actionLabel="全部专题"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Link
            to={`/topics#${feature.id}`}
            className="group reveal relative col-span-1 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7"
          >
            <div className="relative h-64 overflow-hidden bg-background-200 md:h-80">
              <img
                src={feature.cover}
                alt={`${feature.title} 专题配图`}
                title={`${feature.title} - 专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-6">
                <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-label font-medium text-primary-950">
                  <i className="ri-stack-line" aria-hidden="true"></i>
                  {feature.count} 篇稿件
                </span>
                <h3 className="mt-3 font-heading text-2xl font-bold text-background-50">{feature.title}</h3>
                <p className="mt-2 max-w-lg text-sm leading-relaxed text-background-200">{feature.subtitle}</p>
              </div>
            </div>
          </Link>

          <div className="col-span-1 flex flex-col gap-6 lg:col-span-5">
            {others.slice(0, 3).map((topic) => (
              <Link
                key={topic.id}
                to={`/topics#${topic.id}`}
                className="group reveal flex flex-1 items-stretch gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <div className="h-24 w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={topic.cover}
                    alt={`${topic.title} 专题配图`}
                    title={`${topic.title} - 专题`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col justify-center py-1">
                  <div className="flex items-center gap-2 text-xs font-label text-primary-600">
                    <i className="ri-bookmark-line" aria-hidden="true"></i>
                    {topic.count} 篇 · 更新于 {topic.updated}
                  </div>
                  <h3 className="mt-1.5 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {topic.title}
                  </h3>
                  <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{topic.subtitle}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}